<template>
    <div class="wrapper">
        <div class="home-wrapper">
            <router-view></router-view>
        </div>
        <div class="placeholder"></div>
        <div class="bottom-nav">
            <ul class="nav-list">                
                <router-link to="/"  tags='li' class="nav-element">
                    <i class="icon icon-home"></i>
                    <p class="nav-text">Home</p>
                </router-link>
                <!-- <router-link to="/schedule"  tags='li' class="nav-element">
                    <i class="icon icon-scheduled"></i>
                    <p class="nav-text">Scheduled</p>
                </router-link>    -->
                <router-link to="/personal"  class="nav-element" tags='li'>
                    <i class="icon icon-personal"></i>
                    <p class="nav-text">Account</p>
                </router-link>                
            </ul>
        </div>
        <Feedback></Feedback>
    </div>
</template>

<script>
import Feedback from '../components/feedback.vue'
export default {
    components:{
        Feedback
    }
}
</script>
<style lang="less" scoped>
    @import "assets/less/icon.less";
    .wrapper{
        .home-wrapper{
            width: 100%;
            // background:#F6F7FF;
        }
        .placeholder{
            height: 200px;
            width:750px;
            bottom:0            
        }
    }
    .bottom-nav{
        position:fixed;
        bottom:0;
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        padding:30px 0 0;
        z-index: 999999;
        background:#fff;
        .nav-list{            
            .nav-element{
                width: 375px;
                height: 112px;
                float:left;
                // display:flex;
                justify-content: center;
                text-decoration:none;
                .nav-text{
                    text-align: center;
                    color:#A59BB3;
                    font-size: 24px;
                    &.active{
                        color:#BE9060;
                        font-size: 24px;
                    }
                }
            }
            &.router-link-exact-active{
                .nav-text{
                    color:#BE9060;
                }
            }
        }

    }
</style>